import { FLEET_SIZE, TITLES } from '@utils/constants'
import { updateDatalayer } from '@utils/helpers/tracking'
import { useFormContext } from 'react-hook-form'

import { SelectInput } from '../baseInputs'

type Props = {
  name: string
  label?: string
  options?: object
  optionsLabel?: string
  onChange?: (value: string) => void
}

const DropDown = ({ name, optionsLabel, onChange, ...rest }: Props) => {
  const { setValue } = useFormContext()
  const types = {
    model: {
      label: rest.label || 'Model',
      options: [...(rest.options || [])].map((model) => ({
        label:
          model.name +
          (model?.filters?.fuel?.includes('Hybrid') ? ' HYBRID' : ''),
        value: model.d4t4?.id,
      })),
    },
    title: {
      label: 'Title',
      options: TITLES,
    },
    feet_size: {
      label: 'Fleet size',
      options: FLEET_SIZE,
    },
    type_of_enquiry: {
      label: rest.label || 'What would you like to discuss?',
      options: rest.options,
    },
  }

  const handleChange = (e) => {
    setValue(name, e.target.value, { shouldDirty: true })
    if (name === 'model') {
      const selectedModel = [...(rest.options || [])].filter((model) => {
        return e.target.value === model.d4t4.id
      })

      if (selectedModel.length > 0) {
        updateDatalayer('model', {
          name: selectedModel[0].name,
          id: selectedModel[0].image.id,
        })
      } else {
        updateDatalayer('model', false)
      }
    }
    if (onChange) {
      onChange(e)
    }
  }

  return (
    <SelectInput
      optionsLabel={optionsLabel}
      name={name}
      {...types[name]}
      extraOnChange={handleChange}
      {...rest}
    />
  )
}

export default DropDown
